import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBrandKits = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 3.33334V14.1667M15 3.33334L7.5 6.25001H4.16667C3.24619 6.25001 2.5 6.9962 2.5 7.91668V9.58334C2.5 10.5038 3.24619 11.25 4.16667 11.25H5M15 3.33334C16.3807 3.33334 17.5 4.45263 17.5 5.83334V11.6667C17.5 13.0474 16.3807 14.1667 15 14.1667M15 14.1667L7.5 11.25H5M5 11.25V15C5 15.9205 5.74619 16.6667 6.66667 16.6667C7.58714 16.6667 8.33333 15.9205 8.33333 15V11.4583",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBrandKits;
